import React, { useEffect } from 'react';
import Slider from "react-slick";
import './LastPersons.scss';
import arrow from 'assets/images/icons/arrow.svg';
import { Card } from 'components/Card/Card';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { ContentBlock } from 'components/ContentBlock/ContentBlock';
import useLastPersonsVM from './useLastPersonsVM';
import Table from 'components/Table/Table';
import { createColumnHelper } from '@tanstack/react-table';
import { Link } from 'react-router-dom';
import { Person } from 'services/person/person.types';
import moment from 'moment';
import eyeIcon from 'assets/images/icons/eye.svg';
import penIcon from 'assets/images/icons/pen.svg';

export const LastPersons: React.FunctionComponent<{
    isLoading: boolean;
    data: Person[];
}> = ({ isLoading, data }) => {
   
    const { } = useLastPersonsVM();

    const columnHelper = createColumnHelper<Person>();

    const tableColumns = [
        /*columnHelper.accessor('reference', {
            header: 'N° de dossier',
            cell: (info) => info.getValue()
        }),*/
        columnHelper.accessor('fullname', {
            header: 'Nom complet',
            cell: (info) => <i>{info.getValue()}</i>,
            footer: (info) => info.column.id
        }),
        columnHelper.accessor('updated_at', {
            header: 'Dernière actualisation',
            cell: (info) => <i>{moment(info.getValue()).format('DD/MM/YYYY')}</i>,
            footer: (info) => info.column.id
        }),
        columnHelper.display({
            header: 'Actions',
            cell: ({ row: { original: currRow } }) => {
                return (
                    <span style={{ display: 'flex', columnGap: 12 }}>
                        <Link to={`/app/admin/persons/${currRow.id}`}>
                            <img src={eyeIcon} alt="eye-icon" />
                        </Link>
                        <Link to={`/app/admin/persons/${currRow.id}/edit`}>
                            <img src={penIcon} alt="pen-icon" />
                        </Link>
                    </span>
                );
            }
        })
    ];


    return (
        <ContentBlock isLoading={isLoading} className="dashboard-table-persons" title="Derniers dossiers actualisés">
            <Table
                data={data}
                columns={tableColumns}
                columnHelper={columnHelper}
                className="dashboard-table-card"
                pagination={false}
            />
        </ContentBlock>
    );
};
